import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精选深度内容，换个姿势吃瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-500 text-white font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-white/25 text-white font-medium backdrop-blur-sm">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}